import {
  ProductPickerProduct,
  ProductPickerType,
} from "@src/store/slices/productPicker/types";

/**
 * Picker types that must keep selected-but-unloaded products in the loaded
 * list across search/pagination, because their save step resolves variant
 * data from that list. Scoped per-type on purpose — generalizing would inflate
 * getProductPickerLoadedCount (= products.length) for unrelated pickers.
 */
export const preservesSelectedProducts = (type?: ProductPickerType) =>
  type === "checkoutUpsellProductAction" ||
  type === "cartTester" ||
  type === "cartTargeting" ||
  type === "onsiteUpsellAction" ||
  type === "onsiteUpsellCartVariants" ||
  type === "onsiteUpsellPdpProducts";

export const mergeSelectedIntoProducts = (
  currentProducts: ProductPickerProduct[],
  newData: ProductPickerProduct[],
  selectedIds: Set<string>
): ProductPickerProduct[] => {
  const newIds = new Set(newData.map((p) => p.id));
  const preserved = currentProducts.filter(
    (p) => selectedIds.has(p.id) && !newIds.has(p.id)
  );
  return [...preserved, ...newData];
};
